import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';


declare let ConfigData: any;
console.log(ConfigData.ENABLE_CONSOLE_LOGS);

if (!ConfigData.ENABLE_CONSOLE_LOGS) {
    console.log = () => {}; 
    console.warn = () => {};
    console.error = () => {};
    console.info = () => {};
    console.debug = () => {};
}
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
